let SentryInstance = null;

export const getSentry = async () => {
    if (SentryInstance) {
        return SentryInstance;
    }

    const env = window?.etesting?.env;
    const SENTRY_DSN = env?.SENTRY_DSN;
    const RELEASE_VERSION = env?.RELEASE_VERSION || 'UNKNOWN';
    const ENVIRONMENT = env?.ENVIRONMENT || 'UNKNOWN';

    if (SENTRY_DSN) {
        SentryInstance = await import('@sentry/react');

        SentryInstance.init({
            dsn: SENTRY_DSN,
            ignoreErrors: [/getComputedStyle/, /The provider is disconnected from all chains/],
            // Drop noise coming from browser extensions (crypto wallets, etc.)
            denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//],
            integrations: [SentryInstance.replayIntegration()],
            // Capture Replay for 0% of all sessions, can be changed to 100% while debugging,
            // plus for 50% of sessions with an error
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: ENVIRONMENT === 'PRODUCTION' ? 0.5 : 0,
            environment: ENVIRONMENT,
            release: RELEASE_VERSION,
        });
        return SentryInstance;
    }

    return null;
};
